import React from 'react'
import { useParams, useLocation } from 'react-router-dom'

import { ProjectCategory } from './ProjectCategory'
import { ProjectDetail } from './ProjectDetail'

import './projects.scss'


const Projects = ({ links, linkText, pageTitle }) => {
  const { category, slug } = useParams()
  const { pathname } = useLocation()
  const fallbackCategory = links && links[0].url.split(`${pathname}/`)[1]

  // document.title = pageTitle
  return (
    <div className="inner-content project">
      { slug && (
        <ProjectDetail />
      ) }
      { !slug && category && (
        <ProjectCategory
          categoryName={ category }
        />
      ) }
      { !slug && !category && (
        <ProjectCategory
          categoryName={ fallbackCategory }
        />
      )}
    </div>
  )
}

export default Projects